export const Messages = {
  OTP_CONFIRMATION_MESSAGE:
    'You are one step away to complete your password creation. We have sent an OTP to your registered email id. Please enter the otp to complete the process.',
  SET_PWD_REGEX: '(~`!@#$%^&*()+=_-{}[]|:;”’?/<>,.)',
  Support_Success_Message: `Your Request is submit to the admin, the admin team will get in touch with you at the earliest.`,
  Support_Failed_Messages:
    'Oops something went wrong! please try again after some time',
  FORCE_LOGOUT_MESSAGE:
    'Are you sure to close the active session, all the data will be lost, new session will be initiated.',
  CANCEL_MESSAGE: 'Are you sure, all the information saved will be lost.',
  ADD_LOGO_MESSAGE: 'Please add your logo here',
  UPLOAD_LOGO_MESSAGE: 'Update your logo here',
  ADD_VOICE_MAIL_MESSAGE: 'Drop your file here',
  UPLOAD_PROFILE_MESSAGE: 'Drop your image here',
  UPLOAD_CSVFILE_MESSAGE: 'Drop your .CSV file here',
  DISPOSITION_MESSAGE:
    'Our system comes with a set of predefined dispositions. These predefined dispositions are designed to cover the most common scenarios. Feel free to create as many custom dispositions as you need. This flexibility ensures that you can manage your tasks in a way that best suits your processes',
  UPLOAD_AUDIO_MESSAGE: 'Drop your Audio here',
  UPLOAD_FILE_MESSAGE: 'Drop your file here',
  IMPORT_MESSAGE:
    'You are about to import records into ${channel}. Do you wish to continue?',
  DNC_IMPORT_MESSAGE:
    'You are about to import records into your ${channel}. Do you wish to continue?',
  DNC_BLACKLIST_MESSAGE:
    'The records uploaded are already in database, please check the data file and upload again! No records will be saved from this filename.',
  VERIFY_USER_OTP_CONFIRMATION_MESSAGE:
    'You are one step away to complete user verification. We have sent an OTP to your registered email id. Please enter the otp to complete the process.',
  TENANT_PAYMENT_NOT_SUCCEED: 'The subscription has expired so kindly renew it',
  ORGANIZATION_INACTIVE_STATE:
    'Your account is inactive. Please contact the iKunnect admin for assistance.',
  ORGANIZATION_STATUS: 'The Setup of ${organization} is still in progress.',
};
